import { FunctionComponent } from 'react';
import {
    Chip,
    CircularProgress,
    Stack,
    SvgIcon,
    Typography,
} from '@mui/material';
import { CardListRow } from '@starjack/shared-components';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@heroicons/react/24/solid/PencilIcon';
import { TrashIcon } from '@heroicons/react/24/solid';
import { Webshop } from '@/models/webshop';

interface WebshopRowProps {
    webshop: Webshop;
    liftOperatorName: string;
    isLoading: boolean;
    onToggleActiveStatus: (webshop: Webshop) => void;
    onEdit: (webshop: Webshop) => void;
    onDelete: (webshop: Webshop) => void;
}

export const WebshopRow: FunctionComponent<WebshopRowProps> = ({
    webshop,
    liftOperatorName,
    isLoading,
    onToggleActiveStatus,
    onEdit,
    onDelete,
}) => {
    return (
        <CardListRow
            sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Typography sx={{ flex: 1 }}>
                {webshop.vanityIdentifier}
                {liftOperatorName && (
                    <Typography
                        component='span'
                        sx={{
                            ml: 1,
                            color: 'text.secondary',
                            fontSize: '0.875rem',
                        }}
                    >
                        ({liftOperatorName})
                    </Typography>
                )}
            </Typography>

            <Stack
                sx={{
                    ml: 'auto',
                    alignItems: 'center',
                }}
                direction='row'
                spacing={2}
            >
                <Chip
                    label={webshop.active ? 'Aktiv' : 'Inaktiv'}
                    color={webshop.active ? 'success' : 'error'}
                    size='small'
                    variant='filled'
                    onClick={() => onToggleActiveStatus(webshop)}
                    disabled={isLoading}
                    sx={{
                        cursor: isLoading ? 'default' : 'pointer',
                        minWidth: '60px',
                    }}
                    icon={
                        isLoading ? (
                            <CircularProgress size={12} color='inherit' />
                        ) : undefined
                    }
                />
                <IconButton
                    aria-label='Bearbeiten'
                    onClick={() => onEdit(webshop)}
                >
                    <SvgIcon>
                        <EditIcon />
                    </SvgIcon>
                </IconButton>

                <IconButton
                    aria-label='Löschen'
                    onClick={() => onDelete(webshop)}
                >
                    <SvgIcon>
                        <TrashIcon />
                    </SvgIcon>
                </IconButton>
            </Stack>
        </CardListRow>
    );
};
